(() => {
  const BREAKPOINT = 990;
  const OPEN_DELAY = 180;
  const CLOSE_DELAY = 240;

  const detailsList = document.querySelectorAll('[data-fragrance-menu-details]');

  if (!detailsList.length) return;

  const isDesktop = () => window.innerWidth >= BREAKPOINT;

  detailsList.forEach((details) => {
    let openTimer;
    let closeTimer;

    const openMenu = () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        details.open = true;
      }, OPEN_DELAY);
    };

    const closeMenu = () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        details.open = false;
      }, CLOSE_DELAY);
    };

    details.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      openMenu();
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      closeMenu();
    });

    details.addEventListener('focusin', () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      details.open = true;
    });

    details.addEventListener('focusout', () => {
      if (!isDesktop()) return;
      setTimeout(() => {
        if (!details.contains(document.activeElement)) {
          details.open = false;
        }
      }, 10);
    });

    window.addEventListener('resize', () => {
      if (!isDesktop()) {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      }
    });
  });
})();